import Store from 'types/Store/CashieringStore';

export const getReservationOutstandingDeposit = (state: Store) =>
  state.cashiering.reservationOutstandingDeposit.balance;
